import UserUpdatesPopup from "./UserUpdatesPopup";

export default UserUpdatesPopup;
